import { render, staticRenderFns } from "./VideoView.vue?vue&type=template&id=19e2facb&"
import script from "./VideoView.vue?vue&type=script&lang=js&"
export * from "./VideoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports